import React,{useState,useEffect} from "react";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import "./widget.css";
import  axios  from "axios";
Chart.register();

function Statistic({ ...props }) {
  const [chartData, setChartData] = useState([0,0,0,0]);
  const user = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make the API call
        const response = await axios.get(
          `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/month`,
          {
            headers: {
              Authorization: `Bearer ${user.idToken}`,
            },
          }
        );

        // Set the response data to state
       
        
        setChartData((Object.keys(response.data).map(key => response.data[key])).reverse());
        
      } catch (error) {
        // Handle errors
        console.error("Error fetching data:", error);
      }
    };

    // Call the fetch function
    fetchData();
  }, []);
  const getLast4Months =()=> {
    const months = [];
    const monthNames = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];
    const currentDate = new Date();
  
    for (let i = 0; i < 4; i++) {
      const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const monthIndex = newDate.getMonth();
      const month = monthNames[monthIndex].slice(0, 3); // Abbreviated month name
      const year = newDate.getFullYear().toString().slice(2); // Last two digits of the year
  
      months.push(`${month}'${year}`);
    }
  
    return months.reverse(); // Reverse the array to get descending order
  }
  
  const data = {
    labels: getLast4Months(),
    datasets: [
      {
        label: "Amount",
        data: chartData,
      },
      
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 2,
  };
  return (
    <div className={`widgetCard p-3 md:py-4 md:px-6 ${props.className}`}>
      <h1 className="text-medium font-semibold pb-4">Expense Statement</h1>
      <div className="">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}

export default Statistic;
